import api from '@/lib/axios';

export interface NotificationItem {
  _id: string;
  type: string;
  title: string;
  message: string;
  metadata?: Record<string, any>;
  referenceId?: string;
  referenceModel?: 'Project' | 'Task' | string;
  isRead: boolean;
  readAt?: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface NotificationListResponse {
  data: NotificationItem[];
  total: number;
  page: number;
  limit: number;
  hasMore: boolean;
}

export interface NotificationCountsResponse {
  unreadCount: number;
  totalCount: number;
}

export const notificationService = {
  async getNotifications(params: { isRead?: boolean; page?: number; limit?: number } = {}): Promise<NotificationListResponse> {
    const { isRead, page = 1, limit = 20 } = params;
    const query: Record<string, any> = { page, limit };
    if (typeof isRead === 'boolean') query.isRead = isRead;
    const { data } = await api.get<NotificationListResponse>('/notifications', { params: query });
    return data;
  },

  async getCounts(): Promise<NotificationCountsResponse> {
    const { data } = await api.get<NotificationCountsResponse>('/notifications/count');
    return data;
  },

  async markAsRead(notificationIds?: string[]): Promise<{ message: string }> {
    const body = Array.isArray(notificationIds) ? { notificationIds } : {};
    const { data } = await api.patch<{ message: string }>('/notifications/mark-as-read', body);
    return data;
  },
};

export default notificationService;


